import Api from './Api';

export default class ValoresApi {

    mesAnoMunicipio = async (_mes_id, _ano, _municipio_id) => {
        return await Api.get(`valores/mes/${_mes_id}/ano/${_ano}/municipio/${_municipio_id}`).then(response => response.data)
            .catch((error) => console.log('[Valores.mesAnoMunicipio:] Error\n', error));
    }
    mesAnoMunicipioOrdenado = async (_mes_id, _ano, _municipio_id) => {
        return await Api.get(`valores/mes/${_mes_id}/ano/${_ano}/municipio/${_municipio_id}/ordenado`).then(response => response.data)
            .catch((error) => console.log('[Valores.mesAnoMunicipioOrdenado] Error\n', error));
    }
    anos = async () => {
        return await Api.get(`valores/anos`).then(response => response.data)
            .catch((error) => console.log('[VALORES.ANOS:] Error\n', error));
    }
    anosCategoria = async (_categoria_id) => {
        return await Api.get(`valores/anos/categoria/${_categoria_id}`).then(response => response.data)
            .catch((error) => console.log('[VALORES.ANOSCATEGORIA:] Error\n', error));
    }
    relatorio = async (_municipio_id, _ano, _categoria_id) => {
        return await Api.get(`valores/relatorio?municipio_id=${_municipio_id}&ano=${_ano}&categoria_id=${_categoria_id}`).then((response) => response.data)
            .catch((error => console.log('[VALORES][RELATORIO] ERORR\n', error)));

    }
    extratoAnual = async (_ano, _municipio_id) => {
        return await Api.get(`valores/extrato/anual?municipio_id=${_municipio_id}&ano=${_ano}`).then(response => response.data)
            .catch((error) => console.log('[VALORES/EXTRATO/ANUAL] Error\n', error));
    }
    extratoAnualConservacoes = async (_ano, _municipio_id) => {
        return await Api.get(`valores/extrato/anual/conservacoes?municipio_id=${_municipio_id}&ano=${_ano}`).then(response => response.data)
            .catch((error) => console.log('[VALORES/EXTRATO/ANUAL/CONSERVACOES] Error\n', error));
    }
    anoMunicipiosIndicador = async (_ano, _municipios, _indicador_id) => {
        return await Api.get(`valores/ano/${_ano}/municipios/${_municipios}/indicador/${_indicador_id}`).then(response => response.data)
            .catch((error) => console.log('[VALORES.ANOMUNICIPIOINDICADOR:] Error\n', error));
    }
    updateTime = async () => {
        return await Api.get(`valores/updatetime`).then(response => response.data)
            .catch((error) => console.log('[VALORES.UPDATETIME:] Error\n', error));
    }
}